import type { School } from "../../models/school";
import { DataTable, type DataTableProps } from "../datatable/DataTable";
import { StatusIndicator } from "../indicator/StatusIndicator";

type SchoolsTableProps = {
  schools: School[];
} & Required<
  Pick<DataTableProps<School>, "onEdit" | "onDelete" | "onSortStatusChange" | "pagination" | "onPageChange" | "sortStatus" | "fetching">
>;

export function SchoolsTable({ schools, ...props }: SchoolsTableProps) {
  return (
    <DataTable
      records={schools}
      columns={[
        {
          accessor: "title",
          title: "Schule",
          sortable: true,
        },
        {
          accessor: "short",
          title: "Kürzel",
          sortable: true,
          width: "40%",
        },
        {
          accessor: "bms",
          title: "BMS",
          width: "0%",
          render: (school) => <StatusIndicator active={school.bms} />,
          sortable: true,
        },
      ]}
      {...props}
    />
  );
}
